import { WizardAnimationWrapper } from '@/components/WizardAnimationWrapper';
import { Box, Button, Stack, Typography } from '@mui/material';
import MailIcon from '@treyd-io/treyd-ui/icons/MailIcon';
import { t } from 'i18next';

interface EmailSentProps {
  email: string;
  onResendClick: () => void;
  onNext: boolean;
}
export const EmailSent = (props: EmailSentProps) => {
  const { email, onResendClick, onNext } = props;
  return (
    <Stack>
      <WizardAnimationWrapper onNext={onNext} lastStep>
        <Box
          height="100%"
          display="flex"
          justifyContent="center"
          alignItems="center">
          <Box textAlign="center">
            <Box
              display="inline-flex"
              alignItems="center"
              justifyContent="center"
              width={80}
              height={80}
              color="info.main"
              sx={{
                [`& svg`]: {
                  width: '100%',
                  height: '100%',
                },
              }}>
              <MailIcon />
            </Box>
            <Box marginTop={3}>
              <Typography variant="h3">{t('reset_link_sent')}</Typography>

              <Typography variant="body1" marginTop={2}>
                {t('reset_password_link_sent_subtitle', {
                  email: email,
                })}
              </Typography>
            </Box>
            <Box marginTop={3}>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                onClick={onResendClick}>
                {t('resend')}
              </Button>
            </Box>
          </Box>
        </Box>
      </WizardAnimationWrapper>
    </Stack>
  );
};
